/**
 * ISO 4217 currency codes. Duplicated from the Prisma `Currency` enum because `shared/` cannot
 * depend on `@cm/api-prisma` (backend-only) nor `@generated` (frontend-app local) — keep in sync
 * with `backend/packages/prisma/schema/pricing.prisma`.
 */
export enum Currency {
    Aed = "AED",
    Afn = "AFN",
    All = "ALL",
    Amd = "AMD",
    Ang = "ANG",
    Aoa = "AOA",
    Ars = "ARS",
    Aud = "AUD",
    Awg = "AWG",
    Azn = "AZN",
    Bam = "BAM",
    Bbd = "BBD",
    Bdt = "BDT",
    Bgn = "BGN",
    Bhd = "BHD",
    Bif = "BIF",
    Bmd = "BMD",
    Bnd = "BND",
    Bob = "BOB",
    Bov = "BOV",
    Brl = "BRL",
    Bsd = "BSD",
    Btn = "BTN",
    Bwp = "BWP",
    Byn = "BYN",
    Bzd = "BZD",
    Cad = "CAD",
    Cdf = "CDF",
    Che = "CHE",
    Chf = "CHF",
    Chw = "CHW",
    Clf = "CLF",
    Clp = "CLP",
    Cnh = "CNH",
    Cny = "CNY",
    Cop = "COP",
    Cou = "COU",
    Crc = "CRC",
    Cup = "CUP",
    Cve = "CVE",
    Czk = "CZK",
    Djf = "DJF",
    Dkk = "DKK",
    Dop = "DOP",
    Dzd = "DZD",
    Egp = "EGP",
    Ern = "ERN",
    Etb = "ETB",
    Eur = "EUR",
    Fjd = "FJD",
    Fkp = "FKP",
    Gbp = "GBP",
    Gel = "GEL",
    Ghs = "GHS",
    Gip = "GIP",
    Gmd = "GMD",
    Gnf = "GNF",
    Gtq = "GTQ",
    Gyd = "GYD",
    Hkd = "HKD",
    Hnl = "HNL",
    Htg = "HTG",
    Huf = "HUF",
    Idr = "IDR",
    Ils = "ILS",
    Inr = "INR",
    Iqd = "IQD",
    Irr = "IRR",
    Isk = "ISK",
    Jmd = "JMD",
    Jod = "JOD",
    Jpy = "JPY",
    Kes = "KES",
    Kgs = "KGS",
    Khr = "KHR",
    Kmf = "KMF",
    Kpw = "KPW",
    Krw = "KRW",
    Kwd = "KWD",
    Kyd = "KYD",
    Kzt = "KZT",
    Lak = "LAK",
    Lbp = "LBP",
    Lkr = "LKR",
    Lrd = "LRD",
    Lsl = "LSL",
    Lyd = "LYD",
    Mad = "MAD",
    Mdl = "MDL",
    Mga = "MGA",
    Mkd = "MKD",
    Mmk = "MMK",
    Mnt = "MNT",
    Mop = "MOP",
    Mru = "MRU",
    Mur = "MUR",
    Mvr = "MVR",
    Mwk = "MWK",
    Mxn = "MXN",
    Mxv = "MXV",
    Myr = "MYR",
    Mzn = "MZN",
    Nad = "NAD",
    Ngn = "NGN",
    Nio = "NIO",
    Nok = "NOK",
    Npr = "NPR",
    Nzd = "NZD",
    Omr = "OMR",
    Pab = "PAB",
    Pen = "PEN",
    Pgk = "PGK",
    Php = "PHP",
    Pkr = "PKR",
    Pln = "PLN",
    Pyg = "PYG",
    Qar = "QAR",
    Ron = "RON",
    Rsd = "RSD",
    Rub = "RUB",
    Rwf = "RWF",
    Sar = "SAR",
    Sbd = "SBD",
    Scr = "SCR",
    Sdg = "SDG",
    Sek = "SEK",
    Sgd = "SGD",
    Shp = "SHP",
    Sle = "SLE",
    Sos = "SOS",
    Srd = "SRD",
    Ssp = "SSP",
    Stn = "STN",
    Svc = "SVC",
    Syp = "SYP",
    Szl = "SZL",
    Thb = "THB",
    Tjs = "TJS",
    Tmt = "TMT",
    Tnd = "TND",
    Top = "TOP",
    Try = "TRY",
    Ttd = "TTD",
    Twd = "TWD",
    Tzs = "TZS",
    Uah = "UAH",
    Ugx = "UGX",
    Usd = "USD",
    Usn = "USN",
    Uyi = "UYI",
    Uyu = "UYU",
    Uyw = "UYW",
    Uzs = "UZS",
    Ved = "VED",
    Ves = "VES",
    Vnd = "VND",
    Vuv = "VUV",
    Wst = "WST",
    Xaf = "XAF",
    Xag = "XAG",
    Xau = "XAU",
    Xba = "XBA",
    Xbb = "XBB",
    Xbc = "XBC",
    Xbd = "XBD",
    Xcd = "XCD",
    Xdr = "XDR",
    Xof = "XOF",
    Xpd = "XPD",
    Xpf = "XPF",
    Xpt = "XPT",
    Xsu = "XSU",
    Xts = "XTS",
    Xua = "XUA",
    Xxx = "XXX",
    Yer = "YER",
    Zar = "ZAR",
    Zmw = "ZMW",
    Zwg = "ZWG",
}

const CURRENCY_SYMBOLS: Record<Currency, string> = {
    [Currency.Aed]: "د.إ",
    [Currency.Afn]: "؋",
    [Currency.All]: "L",
    [Currency.Amd]: "֏",
    [Currency.Ang]: "ƒ",
    [Currency.Aoa]: "Kz",
    [Currency.Ars]: "$",
    [Currency.Aud]: "$",
    [Currency.Awg]: "ƒ",
    [Currency.Azn]: "₼",
    [Currency.Bam]: "KM",
    [Currency.Bbd]: "$",
    [Currency.Bdt]: "৳",
    [Currency.Bgn]: "лв",
    [Currency.Bhd]: ".د.ب",
    [Currency.Bif]: "FBu",
    [Currency.Bmd]: "$",
    [Currency.Bnd]: "$",
    [Currency.Bob]: "Bs",
    [Currency.Bov]: "BOV",
    [Currency.Brl]: "R$",
    [Currency.Bsd]: "$",
    [Currency.Btn]: "Nu.",
    [Currency.Bwp]: "P",
    [Currency.Byn]: "Br",
    [Currency.Bzd]: "$",
    [Currency.Cad]: "$",
    [Currency.Cdf]: "FC",
    [Currency.Che]: "CHE",
    [Currency.Chf]: "CHF",
    [Currency.Chw]: "CHW",
    [Currency.Clf]: "UF",
    [Currency.Clp]: "$",
    [Currency.Cnh]: "¥",
    [Currency.Cny]: "¥",
    [Currency.Cop]: "$",
    [Currency.Cou]: "COU",
    [Currency.Crc]: "₡",
    [Currency.Cup]: "$",
    [Currency.Cve]: "$",
    [Currency.Czk]: "Kč",
    [Currency.Djf]: "Fdj",
    [Currency.Dkk]: "kr",
    [Currency.Dop]: "RD$",
    [Currency.Dzd]: "د.ج",
    [Currency.Egp]: "ج.م",
    [Currency.Ern]: "Nfk",
    [Currency.Etb]: "Br",
    [Currency.Eur]: "€",
    [Currency.Fjd]: "$",
    [Currency.Fkp]: "£",
    [Currency.Gbp]: "£",
    [Currency.Gel]: "₾",
    [Currency.Ghs]: "₵",
    [Currency.Gip]: "£",
    [Currency.Gmd]: "D",
    [Currency.Gnf]: "FG",
    [Currency.Gtq]: "Q",
    [Currency.Gyd]: "$",
    [Currency.Hkd]: "$",
    [Currency.Hnl]: "L",
    [Currency.Htg]: "G",
    [Currency.Huf]: "Ft",
    [Currency.Idr]: "Rp",
    [Currency.Ils]: "₪",
    [Currency.Inr]: "₹",
    [Currency.Iqd]: "ع.د",
    [Currency.Irr]: "﷼",
    [Currency.Isk]: "kr",
    [Currency.Jmd]: "$",
    [Currency.Jod]: "د.ا",
    [Currency.Jpy]: "¥",
    [Currency.Kes]: "KSh",
    [Currency.Kgs]: "сом",
    [Currency.Khr]: "៛",
    [Currency.Kmf]: "FC",
    [Currency.Kpw]: "₩",
    [Currency.Krw]: "₩",
    [Currency.Kwd]: "د.ك",
    [Currency.Kyd]: "$",
    [Currency.Kzt]: "₸",
    [Currency.Lak]: "₭",
    [Currency.Lbp]: "ل.ل",
    [Currency.Lkr]: "Rs",
    [Currency.Lrd]: "$",
    [Currency.Lsl]: "L",
    [Currency.Lyd]: "ل.د",
    [Currency.Mad]: "د.م.",
    [Currency.Mdl]: "L",
    [Currency.Mga]: "Ar",
    [Currency.Mkd]: "ден",
    [Currency.Mmk]: "K",
    [Currency.Mnt]: "₮",
    [Currency.Mop]: "MOP$",
    [Currency.Mru]: "UM",
    [Currency.Mur]: "Rs",
    [Currency.Mvr]: "Rf",
    [Currency.Mwk]: "MK",
    [Currency.Mxn]: "$",
    [Currency.Mxv]: "MXV",
    [Currency.Myr]: "RM",
    [Currency.Mzn]: "MT",
    [Currency.Nad]: "$",
    [Currency.Ngn]: "₦",
    [Currency.Nio]: "C$",
    [Currency.Nok]: "kr",
    [Currency.Npr]: "रू",
    [Currency.Nzd]: "$",
    [Currency.Omr]: "ر.ع.",
    [Currency.Pab]: "B/.",
    [Currency.Pen]: "S/",
    [Currency.Pgk]: "K",
    [Currency.Php]: "₱",
    [Currency.Pkr]: "₨",
    [Currency.Pln]: "zł",
    [Currency.Pyg]: "₲",
    [Currency.Qar]: "ر.ق",
    [Currency.Ron]: "lei",
    [Currency.Rsd]: "дин",
    [Currency.Rub]: "₽",
    [Currency.Rwf]: "FRw",
    [Currency.Sar]: "ر.س",
    [Currency.Sbd]: "$",
    [Currency.Scr]: "₨",
    [Currency.Sdg]: "ج.س.",
    [Currency.Sek]: "kr",
    [Currency.Sgd]: "$",
    [Currency.Shp]: "£",
    [Currency.Sle]: "Le",
    [Currency.Sos]: "S",
    [Currency.Srd]: "$",
    [Currency.Ssp]: "£",
    [Currency.Stn]: "Db",
    [Currency.Svc]: "₡",
    [Currency.Syp]: "ل.س",
    [Currency.Szl]: "L",
    [Currency.Thb]: "฿",
    [Currency.Tjs]: "SM",
    [Currency.Tmt]: "m",
    [Currency.Tnd]: "د.ت",
    [Currency.Top]: "$",
    [Currency.Try]: "₺",
    [Currency.Ttd]: "$",
    [Currency.Twd]: "$",
    [Currency.Tzs]: "TSh",
    [Currency.Uah]: "₴",
    [Currency.Ugx]: "USh",
    [Currency.Usd]: "$",
    [Currency.Usn]: "USN",
    [Currency.Uyi]: "UYI",
    [Currency.Uyu]: "$",
    [Currency.Uyw]: "UYW",
    [Currency.Uzs]: "сўм",
    [Currency.Ved]: "Bs.D",
    [Currency.Ves]: "Bs",
    [Currency.Vnd]: "₫",
    [Currency.Vuv]: "VT",
    [Currency.Wst]: "$",
    [Currency.Xaf]: "FCFA",
    [Currency.Xag]: "XAG",
    [Currency.Xau]: "XAU",
    [Currency.Xba]: "XBA",
    [Currency.Xbb]: "XBB",
    [Currency.Xbc]: "XBC",
    [Currency.Xbd]: "XBD",
    [Currency.Xcd]: "$",
    [Currency.Xdr]: "XDR",
    [Currency.Xof]: "CFA",
    [Currency.Xpd]: "XPD",
    [Currency.Xpf]: "₣",
    [Currency.Xpt]: "XPT",
    [Currency.Xsu]: "XSU",
    [Currency.Xts]: "XTS",
    [Currency.Xua]: "XUA",
    [Currency.Xxx]: "XXX",
    [Currency.Yer]: "﷼",
    [Currency.Zar]: "R",
    [Currency.Zmw]: "ZK",
    [Currency.Zwg]: "ZiG",
}

export function currencyToSymbol(currency: Currency): string {
    return CURRENCY_SYMBOLS[currency]
}
